import React, { useState, useEffect } from 'react';
import Header from '../adminComponents/header/Header';
import { Box, Button, Paper } from '@mui/material';
import { useFormik } from 'formik';
import ImageUploadField from '../adminComponents/CommonTextField/ImageUploadField';
import CustomTextField from '../adminComponents/CommonTextField/CustomTextField';
import * as Yup from 'yup';
import SuccessModal from '../adminComponents/successModal/SuccessModal';
import { useParams, useNavigate } from 'react-router-dom';
import { addOurCategory, updateOurCategory, getOurCategorybyId } from '../services/OurCategories';
import { useMediaQueries } from '../usecontext/UseProvider';

const validationSchema = Yup.object({
    name: Yup.string().required('The category field is required.'),
    image: Yup.mixed().required('The image field is required.'),
});

const CategoryFormPage = () => {
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [categoryData, setCategoryData] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { setLoading } = useMediaQueries();

    useEffect(() => {
        if (id) {
            const fetchCategory = async () => {
                try {
                    setLoading(true);
                    const response = await getOurCategorybyId(id);
                    if (response?.error) {
                        console.error(response.error);
                    } else {
                        setCategoryData(response.categoryData);
                        formik.setValues({
                            name: response.categoryData.name,
                            image: response.categoryData.image
                        });
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    setLoading(false);
                }
            };
            fetchCategory();
        }
    }, [id]);

    const formik = useFormik({
        initialValues: {
            name: '',
            image: null,
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const formData = new FormData();
                formData.append('name', values.name);
                formData.append('image', values.image);

                let response;
                if (id) {
                    response = await updateOurCategory(formData, id);
                } else {
                    response = await addOurCategory(formData);
                }

                if (response?.error) {
                    console.error(response.error);
                } else {
                    setSuccessModalOpen(true);
                    formik.resetForm();
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        },
    });

    const handleClose = () => {
        navigate('/admin/manage-store/categories');
    };

    const handleSuccessModalClose = () => {
        setSuccessModalOpen(false);
        navigate('/admin/manage-store/categories');
    };

    return (
        <>
            <Header title={id ? "Edit Categories" : "Add Categories"} />
            <Box sx={{ pt: 3 }}>
                <Paper sx={{ p: { sm: 5, xs: 3 } }}>
                    <form onSubmit={formik.handleSubmit}>
                        <Box sx={{ display: { sm: 'flex' }, gap: 3 }}>
                            <Box sx={{ width: { sm: '50%' } }}>
                                <ImageUploadField
                                    label="Image"
                                    name="image"
                                    formik={formik}
                                    data={categoryData}
                                    imageHeight='70px'
                                    imageWidth='70px'
                                />
                                <CustomTextField
                                    label="Category"
                                    name="name"
                                    formik={formik}
                                    placeholder="Enter Category"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                            </Box>
                        </Box>

                        {/* {error && (
                            <Typography color="error" variant='caption'>{error}</Typography>
                        )} */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '10px',
                                    borderColor: '#01A0E2',
                                    color: '#000',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                            >
                                Submit
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Box>
            {/* Success Modal */}
            <SuccessModal
                open={successModalOpen}
                onClose={handleSuccessModalClose}
                message={id ? 'Category updated successfully' : 'Category added successfully'}
            />
        </>
    )
}

export default CategoryFormPage